// src/routes/AppRoutes.tsx

import { useRoutes, useLocation } from 'react-router-dom';
import { generateDynamicRoutes } from './dynamicRoutes';
import { useEffect, useMemo } from 'react';
import { useVersionContext } from '../context/VersionContext';

export const AppRoutes = () => {
  const { currentVersion } = useVersionContext();
  const location = useLocation();

  // ✅ Regenerate routes whenever version changes
  const routes = useMemo(
    () => generateDynamicRoutes(currentVersion.id),
    [currentVersion.id]
  );

  const routeElements = useRoutes(routes);

  useEffect(() => {
    console.log('📍 Current pathname:', location.pathname);
    console.log('🧩 Active version:', currentVersion.id);
  }, [location.pathname, currentVersion.id]);

  return routeElements;
};
